import React from "react";
import { format ,parseISO} from "date-fns";
import Frais from "./frais";
import { useNavigate } from "react-router-dom";
import { fr } from "date-fns/locale"; // For French day names
import { setSelectedEtablissement } from "../store/slices/etablissementSlice";
import { useDispatch } from "react-redux";
import { addSelectedPrestation } from "../store/slices/rendezVousSlice";
import { useSelector } from "react-redux";

const OpeningHours = ({
  horaires = [],
  disponibilites = [],
  status,
  services = {},
  inscrit = true,
}) => {
  const dispatch=useDispatch()
  const navigate = useNavigate();
  // Get today's day name in French (e.g., "lundi")
  const today = format(new Date(), "EEEE", { locale: fr }).toLowerCase();
  const etablissement=useSelector((state)=>state.etablissements.selectedEtablissement)
  const joursEnFrancais = {
    monday: "Lundi",
    tuesday: "Mardi",
    wednesday: "Mercredi",
    thursday: "Jeudi",
    friday: "Vendredi",
    saturday: "Samedi",
    sunday: "Dimanche",
  };
  const formatWeekdayTextold = (weekdayText) => {
    // console.log({weekdayText})
    return weekdayText.map((text) => {
      const [dayPart, hoursPart] = text?.split(": ");
      // console.log(weekdayText);
      const jourKey = dayPart?.trim()?.toLowerCase();
      const jour = joursEnFrancais[jourKey] || dayPart;

      let fermee = false;
      let horaire_ouverture = null;
      let horaire_fermeture = null;

      if (!hoursPart || hoursPart.toLowerCase().includes("fermé")) {
        fermee = true;
      } else if (hoursPart.toLowerCase().includes("24h/24")) {
        horaire_ouverture = "ouvert toute la journée";
        horaire_fermeture = "ouvert toute la journée";
      } else {
        const [open, close] = hoursPart?.split("–")?.map((t) => t.trim());
        horaire_ouverture = open?.replace(/[^0-9:]/g, "");
        horaire_fermeture = close?.replace(/[^0-9:]/g, "");
      }

      return {
        jour,
        fermee,
        horaire_ouverture,
        horaire_fermeture,
      };
    });
  };

  
  
  const formatWeekdayText = (weekdayText) => {
    return weekdayText.map((text) => {
      const [dayPart, hoursPart] = text.split(": ");
      const jourKey = dayPart.trim().toLowerCase();
      const jour = joursEnFrancais[jourKey] || dayPart;
  //  console.log({hoursPart})
      let fermee = false;
      let horaires = []; // Array to store multiple time slots
  
      if (!hoursPart || hoursPart.toLowerCase().includes("closed") || hoursPart.toLowerCase().includes("fermé")) {
        fermee = true;
      } else if (hoursPart.toLowerCase().includes("24h/24") || hoursPart.toLowerCase().includes("24")) {
        horaires.push({
          horaire_ouverture: "00:00",
          horaire_fermeture: "23:59",
        });
      } else {
        // console.log('je serais la')
        // Handle both single and split hours (e.g., "9:00 AM – 1:30 PM, 2:30 – 7:00 PM")
        const timeSlots = hoursPart.split(",").map(slot => slot.trim());
        
        timeSlots.forEach(slot => {
          const [open, close] = slot?.split("–").map(t => t.trim());
          const formattedOpen = open?.replace(/[^0-9:APM]/gi, "")?.replace(/\s+/g, " ");
          const formattedClose = close?.replace(/[^0-9:APM]/gi, "")?.replace(/\s+/g, " ");
          
          // Convert "9:00 AM" → "09:00", "2:30 PM" → "14:30", etc.
          const parseTime = (timeStr) => {
            const [time, period] = timeStr?.split(/(?=[AP]M)/i);
            let [hours, minutes] = time?.split(":");
            
            hours = parseInt(hours, 10);
            if (period?.toUpperCase() === "PM" && hours < 12) hours += 12;
            if (period?.toUpperCase() === "AM" && hours === 12) hours = 0;
            
            return `${hours?.toString()?.padStart(2, '0')}:${minutes || '00'}`;
          };
  
          horaires?.push({
            horaire_ouverture: parseTime(formattedOpen),
            horaire_fermeture: parseTime(formattedClose),
          });
        });
      }
  
      return {
        jour,
        fermee,
        horaires, // Now returns an array of time slots
      };
    });
  };
  const formattedDisponibilites = Object.entries(disponibilites).map(([date, status]) => {
    const dateObj = parseISO(date);
    return {
      date: format(dateObj, 'd'),
      month: format(dateObj, 'MMM', { locale: fr }),
      short: format(dateObj, 'EEE', { locale: fr }),
      active: status === "open"
    };
  });
  const jourOrder = {
    lundi: 1,
    mardi: 2,
    mercredi: 3,
    jeudi: 4,
    vendredi: 5,
    samedi: 6,
    dimanche: 7,
  };
  // console.log({horaires})
  const formattedHoraires = inscrit ? [...horaires].sort((a, b) => jourOrder[a.jour] - jourOrder[b.jour])  :horaires.length && formatWeekdayText(horaires);
  // console.log({ formattedHoraires });
  return (
    <>
      <div className="opening-hours">
        {inscrit && (
          <button
            className="twyny-cta-primary w-100"
            onClick={() => {
              localStorage.removeItem("stepsStatus");
             
              setTimeout(() => {
                navigate(`/choisir-prestation/${etablissement.id}`);
              }, 0);
            }}
          >
            Prendre rendez-vous
          </button>
        )}
        <h5 className="grey500 mt-32">Horaires d'ouverture</h5>

        {inscrit && formattedHoraires?.map((horaire, key, array) => {
          const isToday = horaire.jour.toLowerCase() === today;
          const isLastItem = key === array.length - 1;

          return (
            <React.Fragment key={key}>
              <div className="d-flex justify-content-between mt-24">
                <span
                  className={`${
                    isToday ? "closed body bold500 grey500 capitalize" : "body  grey66 capitalize"
                  }`}
                >
                  {horaire.jour}{" "}
                </span>
                <span
                  className={`${
                    isToday ? "closed body bold500 grey500 " : "body grey500 "
                  }`}
                >
                  {horaire?.fermee ? (
                    <span className="grey66">Fermé</span>
                  ) : (
                    <>
                      {horaire?.horaire_ouverture === "24" ? (
                        <span>Ouvert toute la journée</span>
                      ) : horaire?.horaire_ouverture &&
                        horaire?.horaire_fermeture &&
                        inscrit ? (
                          <>
                          {format(
                            new Date(`1970-01-01T${horaire?.horaire_ouverture}`),
                            "HH:mm"
                          )}{" "}
                          -{" "}
                          {horaire?.continuous === 0 ? (
                            <>
                              {format(
                                new Date(`1970-01-01T${horaire?.pause_debut}`),
                                "HH:mm"
                              )}{" "}/{" "}
                             
                              {format(
                                new Date(`1970-01-01T${horaire?.pause_fin}`),
                                "HH:mm"
                              )}
                              -{" "}
                               {format(
                                new Date(`1970-01-01T${horaire?.horaire_fermeture}`),
                                "HH:mm"
                              )} 
                            </>
                          ) : (
                            format(
                              new Date(`1970-01-01T${horaire?.horaire_fermeture}`),
                              "HH:mm"
                            )
                          )}
                        </>
                      ) : horaire?.horaire_ouverture &&
                        horaire?.horaire_fermeture &&
                        !inscrit ? (
                        <>
                          {horaire?.horaire_ouverture} -{" "}
                          {horaire?.horaire_fermeture}
                        </>
                      ) : (
                        <span>Fermé</span>
                      )}
                    </>
                  )}
                </span>
              </div>
              {!isLastItem && <hr />}
            </React.Fragment>
          );
        })}
        {!inscrit && formattedHoraires?.map((horaire, key, array) => {
          const isToday = horaire.jour.toLowerCase() === today;
          const isLastItem = key === array.length - 1;

          return (
            <React.Fragment key={key}>
              <div className="d-flex justify-content-between mt-24">
                <span
                  className={`${
                    isToday ? "closed body bold500 grey500 capitalize" : "body  grey66 capitalize"
                  }`}
                >
                  {horaire.jour}{" "}
                </span>
                <span className={isToday ? "closed body bold500 grey500 " : "body grey500 "}>
  {horaire.fermee ? (
    <span className="grey66">Fermé</span>
  ) : (
    <>
      {horaire.horaires?.length === 1 ? (
        // Single time slot (no pause)
        <span>
          {horaire.horaires[0].horaire_ouverture} – {horaire.horaires[0].horaire_fermeture}
        </span>
      ) : (
        // Multiple slots = pause (e.g., "9:00 AM – 1:30 PM / 2:30 PM – 7:00 PM")
        <span>
          {horaire.horaires[0].horaire_ouverture} – {horaire.horaires[0].horaire_fermeture}
          {" / "} {/* Indicates a pause */}
          {horaire.horaires[1].horaire_ouverture} – {horaire.horaires[1].horaire_fermeture}
        </span>
      )}
    </>
  )}
</span>
              </div>
              {!isLastItem && <hr />}
            </React.Fragment>
          );
        })}


       
{inscrit && formattedDisponibilites.length > 0 && (
          <>
            <h5 className="grey500 mt-32">Premières disponibilités</h5>
            <div className="schedule-grid mt-24">
              {formattedDisponibilites.map((day, index) => {
                const isActive = day?.active;
                return (
                  <div
                    key={index}
                    className={`day-box ${isActive ? "active" : "inactive"}`}
                  >
                    <div className="day-name">{day.short}</div>
                    <div className="day-date">
                      {day.date} {day.month}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
      {inscrit && (
        <div className="mt-8">
          <Frais />
        </div>
      )}
    </>
  );
};

export default OpeningHours;
